var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEllipseTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 858,
    height: 926,
    viewBox: "0 0 858 926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_2014_1376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.491 881.987C878.64 1025.56 580.35 974.051 332.241 766.938C84.132 559.825 -19.8419 275.537 100.009 131.963C219.859 -11.6106 518.15 39.8986 766.259 247.012C1014.37 454.125 1118.34 738.413 998.491 881.987Z",
    fill: "#04BA96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2014_1376",
    x: 0.226074,
    y: 0.628418,
    width: 1098.05,
    height: 1012.69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_2014_1376"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEllipseTop);
export default __webpack_public_path__ + "static/media/GreenEllipseTop.03cdf3934378c2085002eced6c8e6d9c.svg";
export { ForwardRef as ReactComponent };